import $ from 'jquery';
import {formatMoney} from '@shopify/theme-currency';

/**
 * Module to ajaxify all add to cart forms on the page.
 *
 * Copyright (c) 2015 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

var finalSaleTag = 'final-sale',
    translations = window.translations,
    localeUrl = window.localeUrl;

export function lineItemCardHtml($itemData, $lineItemAddedQuantity = 0){
    // Populate line item into card
    var $lineItemCard = "";

    // Get item image
    var $lineItemImage = '';

    if (typeof $itemData.image != 'undefined' && $itemData.image != '') {
        $lineItemImage = $itemData.image;
    } else if($itemData.featured_image.url){
        $lineItemImage = itemData.featured_image.url;
    }

    // Get item url
    var $lineItemUrl = $itemData.url;
    // Get item title
    var $lineItemTitle = $itemData.product_title;
    // Get item prices
    var $lineItemPrice           = formatMoney($itemData.price, theme.moneyFormat), // Current Price
        $lineItemOriginalPrice   = formatMoney($itemData.original_price, theme.moneyFormat), // Original Price
        $lineItemComparePrice    = '',
        $lineItemComparePriceRaw = null;
    // Get variant title
    if ( $itemData.variant_title != null ) {
        var $lineItemVariantTitle = $itemData.variant_title.replace(' / ', ', ');
    }

    // Get product handle
    var $productHandle = $itemData.handle;
    // Final Sale Product - Check if the product is final sale or not based on tags
    var $isFinalSale = false;
    $.ajax({
        url: localeUrl+'/products/'+ $productHandle +'.js',
        dataType: 'json',
        async: false,
        success: function(product) {

            // get product compare at price max
            $.each(product.variants, function(index, value){
                    
                if( $itemData.id == value.id){
                    console.log(value);
                    $lineItemComparePrice    = formatMoney(value.compare_at_price, theme.moneyFormat);
                    $lineItemComparePriceRaw = value.compare_at_price;
                }
            })

            // Get product tags
            $.each( product.tags, function(index, value){
                if( value == finalSaleTag){
                    $isFinalSale = true;
                    return false;
                }
            } )
        }
    });

    $lineItemCard += '<article class="card card--default card--line-item card--line-item--placeholder">';

        // Image with link
        $lineItemCard += '<a tabindex="-1" href='+ $lineItemUrl +'>';
        if ( $lineItemImage !== null && $lineItemImage != '') {
            $lineItemCard += '<img class="line-item__image" src="'+ $lineItemImage +'"/>';
        }
        $lineItemCard += '</a>';
        $lineItemCard += '<div class="">';
        // Title
        if ( $lineItemTitle.length ) {
            $lineItemCard += '<h3 class="card__title">'+ $lineItemTitle +'</h3>';
        }

        // Meta
        $lineItemCard += '<div class="card__metadata">';
            // Variant Title
            if ( typeof $lineItemVariantTitle != 'undefined' ) {
                $lineItemCard += '<p class="line-item__variant-title">'+ $lineItemVariantTitle +'</p>';
            }

            // Quantity
            if ( $lineItemAddedQuantity > 0 ) {
                var $lineItemQuantity = $lineItemAddedQuantity;
            }else{
                var $lineItemQuantity = $itemData.quantity;
            }
            $lineItemCard += '<p class="line-item__added-quantity">'+ translations.shortQuantity +': '+ $lineItemQuantity +'</p>';

            // Prices
            $lineItemCard += '<div data-price-wrapper="" class="card__price">';
                if ( $lineItemOriginalPrice != $lineItemPrice) {
                    $lineItemCard += '<span class="visually-hidden" data-original-price-text="">Original Price</span>';
                    $lineItemCard += '<s data-original-price="">'+ $lineItemOriginalPrice +'</s>';
                }else if( $lineItemComparePriceRaw != null ){
                    if ( $lineItemComparePrice != $lineItemPrice ) {
                        $lineItemCard += '<span class="visually-hidden" data-compare-text="">Regular price</span>';
                        $lineItemCard += '<s data-compare-price="" class="card__price--sale">'+ $lineItemComparePrice +'</s>';
                    }
                }
                $lineItemCard += '<span data-product-price="" class="card__price--original">'+ $lineItemPrice +'</span>';
            $lineItemCard += '</div>';

            // Final Sale
            if ( $isFinalSale == true ) {
                $lineItemCard += '<div class="line-item__final-sale">';
                    $lineItemCard += '<span>'+ translations.finalSaleLabel +'</span>';
                    $lineItemCard += '<div class="tooltip tooltip--default">';
                        // Tooltip Icon - Final Sale svg - should include via css?
                        $lineItemCard += '<span class="tooltip__icon tooltip__icon--final-sale"><svg class="icon icon__tooltip"><use xlink:href="#icon-tooltip"></use></svg></span>';
                        // Tooltip Description - Final Sale
                        $lineItemCard += '<div class="tooltip__content">'+ translations.finalSaleMessage +'</div>';
                    $lineItemCard += '</div>';
                $lineItemCard += '</div>';
            }

        $lineItemCard += '</div></div>';

    $lineItemCard += '</article>';

    return $lineItemCard;
}

// Get current cart information and output as html
export function cartSubtotalUpdate(cartData){

    var _config = {
        cartCountSelector: '.cart__item-count',
    };

    // Get number of items in cart
    var $cartItemsNum = parseInt(cartData.item_count);
    if( $cartItemsNum > 1 ){
        var $cartItemsNumLabel = translations.itemCountOther;
    }else{
        var $cartItemsNumLabel = translations.itemCountOne;
    }

    var $subTotalLabel = translations.subTotalLabel;

    // Get items subtotal price
    var $cartSubtotal = formatMoney(cartData.items_subtotal_price, theme.moneyFormat);

    if( $('.cart-subtotal__container').length ){

        $.each($('.cart-subtotal__container'), function(){
            $(this).find('.cart-info__item-count').text($subTotalLabel + ' ('+ $cartItemsNum +' '+ $cartItemsNumLabel +')');
            $(this).find('.cart-info__subtotal').text($cartSubtotal);
        })
    }

    // Update cart count
    if ($(_config.cartCountSelector).length) {
        $(_config.cartCountSelector).text(cartData.item_count);
    }
}


$(document).ready(function(){

    Shopify.AjaxifyCart = (function($) {

        // Some configuration options.
        // I have separated what you will never need to change from what
        // you might change.

        var _config = {

            // What you might want to change
            addToCartBtnLabel             : translations.addToCart,
            addedToCartBtnLabel           : translations.addingToCart,
            addingToCartBtnLabel          : translations.addingToCart,
            soldOutBtnLabel               : translations.soldOut,
            howLongTillBtnReturnsToNormal : 800, // in milliseconds.
            cartCountSelector             : '.cart__item-count',
            cartTotalSelector             : '#cart-price',

            // What you will never need to change
            addToCartBtnSelector          : '.btn--add-to-cart--quick',
            addToCartFormSelector         : 'form[action="/cart/add"]',
            shopifyAjaxAddURL             : localeUrl+'/cart/add.js',
            shopifyAjaxCartURL            : localeUrl+'/cart.js',
            productPriceWrapper           : '[data-price-wrapper]',
            productComparePrice           : '[data-compare-price]',
            productQuantityInput          : 'input[name="quantity"]',

            // Cart Confirmation Modal configs
            cartModal                     : '.modal--cart-confirmation',
            cartModalMessage              : '.cart-confirmation__message',
            cartModalItem                 : '.cart-confirmation__item',
            cartModalCartInfo             : '.cart-subtotal__container',
        };

        // We need some feedback when adding an item to the cart.
        // Here it is.
        var _showFeedback = function($itemData) {

            $(_config.cartModalMessage).html(translations.modalSuccessMessage +' <svg class="icon icon__check--circle"><use xlink:href="#icon-check--circle"></use></svg>');

            // Get product quantity added to cart
            var $lineItemAddedQuantity = $(_config.addToCartFormSelector).find(_config.productQuantityInput).val();

            // Get Added Item info and append to the modal
            var $lineItemCardHtml = lineItemCardHtml($itemData, $lineItemAddedQuantity);
            $(_config.cartModalItem).html($lineItemCardHtml);

            // Open the modal after the item is added
            var $modal = $(_config.cartModal);
            $modal.addClass('modal--open');
            $('body').addClass('noscroll');

            $modal.find('[tabindex="-1"]').each(function(){
                $(this).attr('tabindex', 0);
            });

            // Broadcast a notification that a modal opened
            $(window).trigger('open.modal', $modal);

        };

        var _setText = function($button, label) {
            if ($button.children().length) {
                $button.children().each(function() {
                    if ($.trim($(this).text()) !== '') {
                        $(this).text(label);
                    }
                });
            } else {
                $button.text(label);
            }
        };

        var _init = function() {
        $(document).ready(function() {

            // Empty the cart if there are only free sample products in cart

            $.ajax({
                url: _config.shopifyAjaxCartURL,
                cache: false,
                dataType: "json",
                success: function(cart) {

                var cart_items_subtotal_price = cart.items_subtotal_price;
                var cart_item_count           = cart.item_count;
                if (cart_items_subtotal_price == 0 && cart_item_count > 0) {
                    $.ajax({
                        type: "POST",
                        url: localeUrl+'/cart/clear.js',
                        data: '',
                        dataType: 'json',
                        success: function() {
                                location.reload(true);
                        },
                        error: function(XMLHttpRequest, textStatus) {
                            /* error code */
                        }
                    });
                }
            }});

            if ( $(_config.addToCartFormSelector).attr('data-is-ajax') == 'true' ) {

                $('body').on('submit', ""+_config.addToCartFormSelector+"", function(e){
                    e.preventDefault();

                    // Remove error message
                    $('.cart__message--error').text("");

                    var $addToCartForm     = $(this),
                        $addToCartBtn      = $addToCartForm.find(_config.addToCartBtnSelector),
                        $addToCartText     = $addToCartForm.find('[data-add-to-cart-text]'),
                        $addToCartBtnCard  = $addToCartForm.find('.quick-cart-add__loader'),
                        $addToCartType     = $addToCartForm.attr('data-add-cart-type');

                    //Get current label to reapply after cart submitted
                    _config.addToCartBtnLabel = $addToCartText.text();

                    if($('body').hasClass('template-product') && $addToCartForm.hasClass('quick-cart-add__product-hero')) {
                        _setText($addToCartText, _config.addingToCartBtnLabel);
                    }else if($addToCartForm.attr('data-add-cart-type') == 'modal'){ // Cart Modal case
                        // Change Button Text to indicate that product is adding to cart
                        _setText($addToCartText, _config.addingToCartBtnLabel);
                        $addToCartBtn.addClass('disabled').prop('disabled', true);
                        $addToCartBtn.addClass('button--active');
                    }else{
                        _setText($addToCartBtnCard, _config.addingToCartBtnLabel);
                    }

                    // Add to cart.
                    $.ajax({
                        url: _config.shopifyAjaxAddURL,
                        dataType: 'json',
                        type: 'post',
                        data: $addToCartForm.serialize(),
                        success: function(itemData) {
                            // Re-enable add to cart button.
                            $addToCartBtnCard.addClass('button--active');

                            if($addToCartForm.attr('data-add-cart-type') == 'modal'){

                                // // Update mini cart
                                Shopify.miniCart.init();

                                // Update free shipping progress
                                Shopify.freeShippingProgress.init();
                            }

                            if($('body').hasClass('template-product') && $addToCartForm.hasClass('quick-cart-add__product-hero')) {
                                _setText($addToCartText, _config.addedToCartBtnLabel);
                                $addToCartBtn.addClass('disabled').prop('disabled', true);
                                $addToCartBtn.addClass('button--active');

                            }else {
                                _setText($addToCartBtnCard, _config.addedToCartBtnLabel);
                            }

                            window.setTimeout(function(){

                                $addToCartBtnCard.removeClass('button--active');
                                $addToCartBtn.removeClass('button--active');
                                $addToCartBtn.removeClass('disabled').prop('disabled', false);

                                if($('body').hasClass('template-product') && $addToCartForm.hasClass('quick-cart-add__product-hero')) {
                                    _setText($addToCartText, _config.addToCartBtnLabel);
                                }else if($addToCartForm.attr('data-add-cart-type') == 'modal'){ // Cart Modal case
                                    _setText($addToCartText, _config.addToCartBtnLabel);
                                    _showFeedback(itemData);

                                    // ---------------------------------------------
                                    // Trap Focus inside the Cart Confirmation Modal
                                    // ---------------------------------------------

                                    // add all the elements inside modal which you want to make focusable
                                    const  focusableElements    = '[tabindex]:not([tabindex="-1"]), [href]';
                                    const modal                 = document.querySelector('#modal_cart_confirmation'); // select the modal by it's id
                                    const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
                                    const focusableContent      = modal.querySelectorAll(focusableElements);
                                    const lastFocusableElement  = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

                                    document.addEventListener('keydown', function(e) {
                                        let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

                                        if (!isTabPressed) {
                                            return;
                                        }

                                        if (e.shiftKey) { // if shift key pressed for shift + tab combination

                                            if (document.activeElement === firstFocusableElement) {

                                                lastFocusableElement.focus(); // add focus for the last focusable element
                                                e.preventDefault();
                                            }
                                        } else { // if tab key is pressed

                                            if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab

                                                firstFocusableElement.focus(); // add focus for the first focusable element
                                                e.preventDefault();
                                            }
                                        }
                                    });
                                }
                            }, _config.howLongTillBtnReturnsToNormal);

                            // Update cart count

                            $.ajax({
                                url: _config.shopifyAjaxCartURL,
                                cache: false,
                                dataType: "json",
                                success: function(cart) {

                                if (_config.cartCountSelector && $(_config.cartCountSelector).length) {
                                    $(_config.cartCountSelector).text(cart.item_count);
                                }
                            }});
                        },
                        error: function(XMLHttpRequest) {
                            var response = eval('(' + XMLHttpRequest.responseText + ')');
                            response = response.description;
                            if (response.slice(0,4) === 'All ') {
                                $('.cart__message--error').text("You can't add more of this product to the cart.");
                                 _setText($addToCartText, _config.soldOutBtnLabel);
                                $addToCartBtn.prop('disabled',true);
                            }
                            else {
                                $('.cart__message--error').text(response);
                                $addToCartBtn.prop('disabled', false).removeClass('disabled');
                                _setText($addToCartText, _config.addToCartBtnLabel);
                            }
                        }
                    });
                    return false;

                })
            }

            });
        };
        return {
            init: function(params) {
                    // Configuration
                    params = params || {};
                    // Merging with defaults.
                    $.extend(_config, params);
                    // Action
                    $(function() {
                        _init();
                    });
            },
            getConfig: function() {
                return _config;
            }
        }
    })($);
    Shopify.AjaxifyCart.init();
});
